import { Pane } from 'tweakpane';

// The ranges are the whole point of this panel: every value a visitor can reach
// produces an output we would ship. There is nothing to get wrong.
const RANGES = {
  count: { min: 400, max: 2600, step: 20 },
  size: { min: 12, max: 70, step: 1 },
  flow: { min: 100, max: 400, step: 5 },
};

/**
 * Tweakpane writes straight into the same params object the renderer reads, so
 * a slider change needs no plumbing beyond a redraw.
 */
export default function createControls(params, { onChange, reseed, download }) {
  const pane = new Pane({
    container: document.querySelector('#controls'),
    title: 'Flow Field',
  });

  pane.addBinding(params, 'count', { label: 'particles', ...RANGES.count });
  pane.addBinding(params, 'size', { label: 'size', ...RANGES.size });
  pane.addBinding(params, 'flow', { label: 'flow', ...RANGES.flow });

  pane.addButton({ title: 'Randomize' }).on('click', () => {
    Object.keys(RANGES).forEach(key => {
      params[key] = randomInRange(RANGES[key]);
    });
    pane.refresh();
    onChange();
  });

  pane.addButton({ title: 'New field' }).on('click', reseed);
  pane.addButton({ title: 'Download PNG' }).on('click', download);

  pane.on('change', onChange);

  return pane;
}

function randomInRange({ min, max, step }) {
  const steps = Math.floor((max - min) / step);
  return min + Math.round(Math.random() * steps) * step;
}
